/** Keeps org-switcher links between beta hosts and preserves other configured destinations. */
export const resolvePeerProductUrl = (
  configuredUrl: string | undefined,
  hostname: string
): string | undefined => {
  if (!configuredUrl) {
    return configuredUrl
  }
  switch (hostname) {
    case 'beta.motif.io':
      return 'https://design-preview.motif.io'
    case 'design-preview.motif.io':
      return 'https://beta.motif.io'
    default:
      return configuredUrl
  }
}
